import { GraphQLExecutor } from '@app/model/_common/service/GraphQLExecutor';
import MarketStateFilterInput from '@app/model/market_state/input/MarketStateFilterInput';
import { ChannelCheckSnapshot } from '@app/model/channel_check/ChannelCheckModels';
import { FIND_CHANNEL_CHECK_FOR_PERIOD } from '@app/model/channel_check/service/ChannelCheckGraphQLQueries';

export class ChannelCheckService {
	static findForPeriod(companyHotelId: number, startStatDate: string, endStatDate: string,
		filterInput: MarketStateFilterInput, includeStaleChannels: boolean) {
		return GraphQLExecutor.execute<ChannelCheckSnapshot>(FIND_CHANNEL_CHECK_FOR_PERIOD, {
			companyHotelId, startStatDate, endStatDate, filterInput, includeStaleChannels,
		});
	}
}
